export default __webpack_public_path__ + "static/alfred_search_file-7b0e9ae17ba053f5a0ab6243731c0ffa.png";